import { baseClient } from "./baseRequest";

export type ShopifyProductPageResponse = {
  previewUrl: string;
  // Public online-store URL, returned once the collection is published.
  productUrl?: string;
};

export type ShopifyProductPageApiClient = {
  getCollectionShopifyPreviewUrl: (
    collectionId: string,
  ) => Promise<ShopifyProductPageResponse>;
};

const shopifyProductPageApiClient: ShopifyProductPageApiClient = {
  getCollectionShopifyPreviewUrl: async (collectionId: string) => {
    return baseClient.get<ShopifyProductPageResponse>({
      url: `/shopify-product-page/collection/${collectionId}`,
    });
  },
};

export default shopifyProductPageApiClient;
